import { combineReducers } from 'redux';

import summary from '../../summary/reducers';
import offerSubscriptionForm from '../../offer-form/reducers';

export default combineReducers({
  summary,
  offerSubscriptionForm
});
